import React from 'react';
import { useApp } from '../context/AppContext';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeroCarousel from '../components/HeroCarousel';
import { SeasonalBanner } from '../components/SeasonalBanner';
import { SeasonalTheme } from '../components/SeasonalTheme';
import EssentialsKit from '../components/EssentialsKit';
import ProductGrid from '../components/ProductGrid';
import ProductModal from '../components/ProductModal';
import CartSheet from '../components/CartSheet';
import CheckoutModal from '../components/CheckoutModal';
import { Routes, Route } from 'react-router-dom';
import ContentPage from './ContentPage';
import PartnersPage from './PartnersPage';
import ReviewsPage from './ReviewsPage';
import OrderPortalPage from './OrderPortalPage';
import HelpWidget from '../components/HelpWidget';
import HomeReviews from '../components/HomeReviews';
import PartnerLogoStrip from '../components/PartnerLogoStrip';

const Home = () => {
  const { quickView: selected, setQuickView: setSelected } = useApp();
  return (
    <div className="min-h-screen bg-[hsl(var(--bg-canvas))] text-[hsl(var(--fg-primary))] relative overflow-x-clip">
      {/* Ambient bold-modern background — subtle emerald wash + spotlight */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[560px] opacity-70 dark:opacity-60"
        style={{
          background:
            'radial-gradient(1200px 420px at 15% -10%, hsl(var(--brand) / 0.14), transparent 60%),' +
            'radial-gradient(900px 380px at 90% -20%, hsl(var(--brand) / 0.10), transparent 55%)',
        }}
      />
      <div className="relative flex flex-col min-h-screen">
      <Header />
      <SeasonalTheme />
      <div className="flex-1">
      <Routes>
        <Route path="page/:slug" element={<ContentPage />} />
        <Route path="partners" element={<PartnersPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="order/:id" element={<OrderPortalPage />} />
        <Route path="*" element={<>
          <SeasonalBanner />
          <HeroCarousel />
          <EssentialsKit />
          <PartnerLogoStrip />
          <ProductGrid onView={setSelected} />
          <HomeReviews />
        </>} />
      </Routes>
      </div>
      {selected && <ProductModal product={selected} onClose={()=>setSelected(null)} />}
      <Footer />
      <HelpWidget />
      <CartSheet />
      <CheckoutModal />
      </div>
    </div>
  );
};

export default Home;
